export type errorCodes = typeof errorCodeValues[number];

export const errorCodeValues = [
    '',

    'in_progress',

    'commandbuilder_failed',
    'querybuilder_failed',

    'client_error',
    'client_refresh_failed',

    'unhandled_condition',
    'error_thrown',
    'invalid_user',
    'invalid_site',
    'invalid_user_or_site',
    'user_disabled',
    'site_disabled',
    'portal_disabled',
    'invalid_site_or_user',
    'error', // 400 
    'invalid_request', // 400
    'auth_invalid_token', // 400
    'auth_required', // 401

    'permission_insufficient', // command/query specific permission missing
    'requires_authentication',

    'addActivityParticipant_id_in_use',
    'addActivityParticipant_invalid_activityId',
    'addActivityParticipant_invalid_id',
    'addActivityParticipant_invalid_userId',
    'addActivityParticipant_userId_already_added',
    'addActivityParticipant_activityType_does_not_allow_participants',
    'addActivityParticipant_invalid_target_user_permission',

    'addExternalActivityParticipant_id_in_use',
    'addExternalActivityParticipant_invalid_activityId',
    'addExternalActivityParticipant_invalid_email',
    'addExternalActivityParticipant_invalid_id',
    'addExternalActivityParticipant_invalid_name',
    'addExternalActivityParticipant_invalid_role',
    'addExternalActivityParticipant_email_in_use',
    'addExternalActivityParticipant_activityType_does_not_allow_participants',

    'addPlannedCourse_id_in_use',
    'addPlannedCourse_invalid_courseId',
    'addPlannedCourse_invalid_id',
    'addPlannedCourse_invalid_userId',

    'addWorkgroupMember_invalid_userId',
    'addWorkgroupMember_invalid_workgroupId',
    'addWorkgroupMember_user_already_member',

    'adminUpdateUserEmail_invalid_userId',
    'adminUpdateUserEmail_invalid_newEmail',
    'adminUpdateUserEmail_user_disabled',
    'adminUpdateUserEmail_email_in_use',

    'adminUpdateUserPassword_invalid_userId',
    'adminUpdateUserPassword_invalid_newPassword',
    'adminUpdateUserPassword_user_disabled',

    'assignActionPlanOwner_invalid_id',
    'assignActionPlanOwner_invalid_userId',
    'assignActionPlanOwner_user_disabled',

    'assignArticleOwner_invalid_articleId_format',
    'assignArticleOwner_invalid_ownerUserId_format',
    'assignArticleOwner_invalid_articleId',
    'assignArticleOwner_invalid_userId',
    'assignArticleOwner_user_disabled',
    'assignArticleOwner_user_insufficient_permissions',

    'assignIndividualPermission_invalid_userId',
    'assignIndividualPermission_invalid_permission',
    'assignIndividualPermission_not_assigned',
    'assignIndividualPermission_invalid_target_permissionGroup',

    'changeUserPassword_incorrect_oldPassword',
    'changeUserPassword_invalid_newPassword',
    'changeUserPassword_invalid_oldPassword',
    'changeUserPassword_invalid_userId',
    'changeUserPassword_user_disabled',

    'completePlannedCourse_can_not_complete_custom_course',
    'completePlannedCourse_invalid_completedDate',
    'completePlannedCourse_invalid_id',
    'completePlannedCourse_invalid_status',

    'confirmPortalMagicLink_site_not_found',
    'confirmPortalMagicLink_portal_disabled',
    'confirmPortalMagicLink_magic_link_disabled',
    'confirmPortalMagicLink_invalid_email_format',
    'confirmPortalMagicLink_invalid_email_domain',
    'confirmPortalMagicLink_request_not_found',
    'confirmPortalMagicLink_requestId_mismatch',
    'confirmPortalMagicLink_request_expired',

    'confirmNewUserEmail_invalid_requestId',
    'confirmNewUserEmail_invalid_userId',
    'confirmNewUserEmail_no_requests_exist',
    'confirmNewUserEmail_user_disabled',
    'confirmNewUserEmail_email_in_use',

    'confirmPasswordReset_invalid_newPassword',
    'confirmPasswordReset_invalid_requestId',
    'confirmPasswordReset_invalid_userId',
    'confirmPasswordReset_no_requests_exist',
    'confirmPasswordReset_user_disabled',

    'confirmUserCreation_invalid_requestId',
    'confirmUserCreation_invalid_userId',
    'confirmUserCreation_no_requests_exist',
    'confirmUserCreation_userId_in_use',
    'confirmUserCreation_email_in_use',

    'createActionPlan_invalid_id',
    'createActionPlan_invalid_activityId',
    'createActionPlan_invalid_activityType',
    'createActionPlan_invalid_type',
    'createActionPlan_type_mismatch',
    'createActionPlan_activity_not_yet_passed',
    'createActionPlan_id_in_use',
    'createActionPlan_non_empty_wpa_segmentfilter',
    'createActionPlan_meeting_action_plan_exists',
    'createActionPlan_no_access',

    'createActionPlanLink_invalid_actionPlanId_format',
    'createActionPlanLink_invalid_linkId_format',
    'createActionPlanLink_invalid_actionPlanId_value',
    'createActionPlanLink_no_access_for_actionPlan',
    'createActionPlanLink_invalid_configuration_format',
    'createActionPlanLink_linkId_in_use',
    'createActionPlanLink_actionPlan_has_link',
    'createActionPlanLink_actionplanTopic_has_link',
    'createActionPlanLink_actionPoint_has_link',

    'createActionPlanTopic_invalid_id',
    'createActionPlanTopic_invalid_actionPlanId',
    'createActionPlanTopic_id_in_use',
    'createActionPlanTopic_no_access_for_actionPlan',

    'createMeetingAgendaItemTopic_invalid_id',
    'createMeetingAgendaItemTopic_invalid_agendaItemId',
    'createMeetingAgendaItemTopic_agendaItem_not_in_meeting',
    'createMeetingAgendaItemTopic_topic_already_exists',
    'createMeetingAgendaItemTopic_id_in_use',
    'createMeetingAgendaItemTopic_no_access',
    'createMeetingAgendaItemTopic_no_meeting_action_plan',

    'createActionPoint_invalid_id_format',
    'createActionPoint_invalid_relation',
    'createActionPoint_invalid_description',
    'createActionPoint_invalid_assignedUser',
    'createActionPoint_invalid_deadline',
    'createActionPoint_id_in_use',
    'createActionPoint_invalid_assignedUser_userId',
    'createActionPoint_no_access_for_actionPlan',
    'createActionPoint_invalid_relation_format',

    'createActivity_id_in_use',
    'createActivity_invalid_activityType',
    'createActivity_invalid_description',
    'createActivity_invalid_start',
    'createActivity_invalid_end',
    'createActivity_invalid_duration',
    'createActivity_invalid_id',
    'createActivity_invalid_location',
    'createActivity_invalid_title',

    'createAgendaItem_agendaItem_not_allowed_for_nonMeeting',
    'createAgendaItem_id_in_use',
    'createAgendaItem_invalid_activityId',
    'createAgendaItem_invalid_description',
    'createAgendaItem_invalid_note',
    'createAgendaItem_invalid_id',
    'createAgendaItem_invalid_title',

    'loadMeetingTemplate_invalid_activityId',
    'loadMeetingTemplate_invalid_templateId',
    'loadMeetingTemplate_not_allowed_for_nonAnnualMeeting',

    'createAllFacilityInspections_invalid_activityId',
    'createAllFacilityInspections_invalid_facilityId',
    'createAllFacilityInspections_invalid_activityType',

    'createAllLocationInspections_invalid_activityId',
    'createAllLocationInspections_invalid_locationId',
    'createAllLocationInspections_invalid_activityType',

    'createArticleEvaluation_invalid_articleVersionId',
    'createArticleEvaluation_invalid_evaluationImportance',
    'createArticleEvaluation_invalid_evaluationText',
    'createArticleEvaluation_already_evaluation_exists',
    'createArticleEvaluation_article_not_released',

    'createComment_invalid_id_format',
    'createComment_invalid_reference_format',
    'createComment_invalid_content',
    'createComment_invalid_reference',
    'createComment_id_in_use',

    'createCourse_id_in_use',
    'createCourse_invalid_contactEmail',
    'createCourse_invalid_contactPhone',
    'createCourse_invalid_contactUrl',
    'createCourse_invalid_day',
    'createCourse_invalid_days',
    'createCourse_invalid_description',
    'createCourse_invalid_id',
    'createCourse_invalid_location',
    'createCourse_invalid_provider',
    'createCourse_invalid_signupDeadline',
    'createCourse_invalid_title',
    'createCourse_invalid_type',

    'createCustomCourse_id_in_use',
    'createCustomCourse_invalid_completedDate',
    'createCustomCourse_invalid_description',
    'createCustomCourse_invalid_id',
    'createCustomCourse_invalid_provider',
    'createCustomCourse_invalid_title',
    'createCustomCourse_invalid_type',
    'createCustomCourse_invalid_userId',

    'createCustomForm_invalid_id',
    'createCustomForm_invalid_activityId',
    'createCustomForm_invalid_templateId',
    'createCustomForm_invalid_activityType',
    'createCustomForm_id_in_use',
    'createCustomForm_activity_already_has_survey',

    'createExternalLink_invalid_id_format',
    'createExternalLink_invalid_title',
    'createExternalLink_invalid_description',
    'createExternalLink_invalid_url',
    'createExternalLink_invalid_iconName',
    'createExternalLink_invalid_showInMenu',
    'createExternalLink_id_in_use',

    'createFacilityType_invalid_id',
    'createFacilityType_invalid_name',
    'createFacilityType_id_in_use',

    'createActivityAndActionPlan_invalid_actionPlanId',
    'createActivityAndActionPlan_invalid_activityId',
    'createActivityAndActionPlan_invalid_actionPlanTypeData',
    'createActivityAndActionPlan_invalid_title',
    'createActivityAndActionPlan_invalid_start',
    'createActivityAndActionPlan_invalid_end',
    'createActivityAndActionPlan_invalid_end_before_start',
    'createActivityAndActionPlan_activityId_in_use',
    'createActivityAndActionPlan_actionPlanId_in_use',

    'createInspectionPoint_invalid_id',
    'createInspectionPoint_invalid_availability',
    'createInspectionPoint_invalid_title',
    'createInspectionPoint_invalid_instructions',
    'createInspectionPoint_id_in_use',
    'createInspectionPoint_invalid_config',

    'createInternalArticle_invalid_internalArticleId_format',
    'createInternalArticle_invalid_title_format',
    'createInternalArticle_invalid_description_format',
    'createInternalArticle_invalid_ownerUserId_format',
    'createInternalArticle_invalid_changeId_format',
    'createInternalArticle_invalid_changeDescription_format',
    'createInternalArticle_invalid_date_format',
    'createInternalArticle_invalid_evaluationImportance_format',
    'createInternalArticle_invalid_evaluationText_format',
    'createInternalArticle_internalArticleId_in_use',
    'createInternalArticle_invalid_userId',
    'createInternalArticle_user_disabled',
    'createInternalArticle_user_insufficient_permissions',
    'createInternalArticle_changeId_in_use',
    
    'createInternalArticleChange_invalid_internalArticleId_format',
    'createInternalArticleChange_invalid_changeId_format',
    'createInternalArticleChange_invalid_internalArticleId',
    'createInternalArticleChange_changeId_in_use',

    'createFacility_id_in_use',
    'createFacility_id_in_use1',
    'createFacility_invalid_id_format',
    'createFacility_invalid_name',
    'createFacility_invalid_building',
    'createFacility_invalid_floor',
    'createFacility_invalid_facility_type_id',
    'createFacility_invalid_location_id',
    'createFacility_invalid_locationId',
    'createFacility_invalid_created_date',

    'createFacilityInspection_invalid_activityId',
    'createFacilityInspection_invalid_facilityId',
    'createFacilityInspection_invalid_inspectionPointId',
    'createFacilityInspection_invalid_id',
    'createFacilityInspection_invalid_activityType',
    'createFacilityInspection_inspectionPointId_in_use',

    'createFileFolder_invalid_id_format',
    'createFileFolder_invalid_name',
    'createFileFolder_invalid_parent_folder_id',
    'createFileFolder_id_in_use',
    'createFileFolder_name_in_use_by_sibling',

    'createLocation_id_in_use',
    'createLocation_invalid_id_format',
    'createLocation_invalid_name',
    'createLocation_invalid_country',
    'createLocation_invalid_address',
    'createLocation_invalid_postal_code',
    'createLocation_invalid_city',
    'createLocation_invalid_created_date',

    'createIncident_portal_disabled',
    'createIncident_id_in_use',
    'createIncident_invalid_id_format',
    'createIncident_invalid_type',
    'createIncident_invalid_title',
    'createIncident_invalid_description',
    'createIncident_invalid_solutionDescription',
    'createIncident_invalid_anonymousSelected',
    'createIncident_invalid_email',
    'createIncident_invalid_name',
    'createIncident_invalid_notificationsSelected',
    'createIncident_invalid_fileUploadSlotId',
    'createIncident_anonymous_name_conflict',
    'createIncident_anonymous_email_conflict',
    
    'createPerson_id_in_use',
    'createPerson_invalid_type',
    'createPerson_invalid_id_format',
    'createPerson_invalid_name',
    'createPerson_invalid_role',
    'createPerson_invalid_email',
    'createPerson_invalid_phone',

    'createSurvey_id_in_use',
    'createSurvey_invalid_id',
    'createSurvey_invalid_activityId',
    'createSurvey_activity_already_has_survey',
    'createSurvey_invalid_introduction',
    'createSurvey_invalid_type',

    'createSurveyQuestion_editing_not_allowed',
    'createSurveyQuestion_invalid_indicators',
    'createSurveyQuestion_invalid_surveyId',
    'createSurveyQuestion_invalid_themeIndex',
    'createSurveyQuestion_invalid_title',
    'createSurveyQuestion_title_in_use',
    'createSurveyQuestion_invalid_type',
    'createSurveyQuestion_invalid_invertScore',
    'createSurveyQuestion_invalid_scored',
    'createSurveyQuestion_invalid_canComment',
    'createSurveyQuestion_invalid_options',
    'createSurveyQuestion_question_limit_reached',
    'createSurveyQuestion_invalid_config',
    'createSurveyQuestion_invalid_option_translation',
    'createSurveyQuestion_invalid_conditional',
    'createSurveyQuestion_invalid_conditional_values',
    'createSurveyQuestion_invalid_conditional_type',
    'createSurveyQuestion_invalid_conditional_trigger',
    'createSurveyQuestion_invalid_conditional_sequence',

    'createSurveyReportLink_invalid_surveyId_format',
    'createSurveyReportLink_invalid_linkId_format',
    'createSurveyReportLink_invalid_segmentFilter_format',
    'createSurveyReportLink_invalid_surveyId_value',
    'createSurveyReportLink_linkId_in_use',
    'createSurveyReportLink_invalid_segmentFilter_value',
    'createSurveyReportLink_segmentFilter_double',
    'createSurveyReportLink_segmentFilter_inUse',

    'createSurveySegmentFilterAlias_invalid_surveyId_format',
    'createSurveySegmentFilterAlias_invalid_aliasId_format',
    'createSurveySegmentFilterAlias_invalid_name',
    'createSurveySegmentFilterAlias_invalid_segmentFilter_format',
    'createSurveySegmentFilterAlias_invalid_surveyId',
    'createSurveySegmentFilterAlias_invalid_segmentFilter_value',
    'createSurveySegmentFilterAlias_aliasId_in_use',
    'createSurveySegmentFilterAlias_name_in_use',
    'createSurveySegmentFilterAlias_segmentFilter_in_use',

    'createSurveySegmentation_invalid_surveyId',
    'createSurveySegmentation_invalid_surveyId_format',
    'createSurveySegmentation_editing_not_allowed',
    'createSurveySegmentation_invalid_languagecode',
    'createSurveySegmentation_inconsistent_value_count',
    'createSurveySegmentation_inconsistent_translation_definition',
    'createSurveySegmentation_duplicate_segmentation_name',
    'createSurveySegmentation_invalid_data_format',
    'createSurveySegmentation_invalid_value_count',
    'createSurveySegmentation_invalid_segmentation_value',
    'createSurveySegmentation_duplicate_segmentation_value',
    'createSurveySegmentation_invalid_segmentation_name',

    'createSurveyTheme_invalid_surveyId',
    'createSurveyTheme_invalid_name',
    'createSurveyTheme_editing_not_allowed',
    'createSurveyTheme_name_in_use',

    'createSurveyTranslation_invalid_surveyId_format',
    'createSurveyTranslation_invalid_languageCode',
    'createSurveyTranslation_invalid_surveyId',
    'createSurveyTranslation_editing_not_allowed',
    'createSurveyTranslation_language_is_default',
    'createSurveyTranslation_translation_exists',

    'createTemplateFromSurvey_invalid_surveyId_format',
    'createTemplateFromSurvey_invalid_surveyTemplateId_format',
    'createTemplateFromSurvey_surveyTemplateId_in_use',
    'createTemplateFromSurvey_invalid_surveyId',
    'createTemplateFromSurvey_invalid_description',

    'createUser_email_in_use',
    'createUser_invalid_email',
    'createUser_invalid_firstname',
    'createUser_invalid_id',
    'createUser_invalid_lastname',
    'createUser_invalid_middlename',
    'createUser_invalid_password',
    'createUser_id_in_use',

    'createUserRole_invalid_id',
    'createUserRole_invalid_duration',
    'createUserRole_invalid_roleId',
    'createUserRole_invalid_userId',
    'createUserRole_invalid_start',
    'createUserRole_invalid_end',
    'createUserRole_id_in_use',

    'importUsers_no_users',
    'importUsers_too_many_users',
    'importUsers_invalid_permissionGroup',
    'importUsers_invalid_password',
    'importUsers_invalid_firstname',
    'importUsers_invalid_lastname',
    'importUsers_invalid_email',
    'importUsers_duplicate_email',
    'importUsers_email_in_use',

    'createWorkgroup_id_in_use',
    'createWorkgroup_invalid_id',
    'createWorkgroup_invalid_name',

    'deleteActionPlan_invalid_id_format',
    'deleteActionPlan_invalid_id',

    'deleteActionPlanLink_invalid_linkId_format',
    'deleteActionPlanLink_no_access_for_actionPlan',
    'deleteActionPlanLink_invalid_linkId_value',

    'deleteActionPlanTopic_invalid_id_format',
    'deleteActionPlanTopic_invalid_id',
    'deleteActionPlanTopic_no_access_for_actionPlan',

    'deleteActionPoint_invalid_id',
    'deleteActionPoint_invalid_id_format',
    'deleteActionPoint_invalid_relation',
    'deleteActionPoint_no_access_for_actionPlan',

    'deleteActivity_invalid_id',
    'deleteActivity_survey_has_actionplans',

    'deleteAgendaItem_has_children',
    'deleteAgendaItem_invalid_activityId',
    'deleteAgendaItem_invalid_id',

    'deleteAllSurveyAnswers_invalid_surveyId',

    'deleteComment_invalid_id_format',
    'deleteComment_invalid_id',
    'deleteComment_not_authorized',

    'deleteExternalLink_invalid_id_format',
    'deleteExternalLink_invalid_id',

    'deleteFacility_invalid_id',
    'deleteFacility_invalid_id_format',
    'deleteFacility_has_inspections',

    'deleteFacilityInspection_invalid_activityId',
    'deleteFacilityInspection_invalid_id',
    'deleteFacilityInspection_invalid_activityType',
    'deleteFacilityInspection_has_non-pending_status',
    'deleteFacilityInspection_has_comment',
    'deleteFacilityInspection_has_files',

    'deleteFacilityInspectionImage_invalid_facilityInspectionId',
    'deleteFacilityInspectionImage_invalid_privateFileName',

    'deleteFile_invalid_private_file_name',
    'deleteFile_file_not_found', 

    'deleteFileFolder_invalid_id_format',
    'deleteFileFolder_invalid_id',
    'deleteFileFolder_has_subfolders',
    'deleteFileFolder_has_files',

    'deleteLocation_invalid_id',
    'deleteLocation_invalid_id_format',
    'deleteLocation_valid_id',

    'deletePerson_invalid_id_format',
    'deletePerson_invalid_id',
    'deletePerson_id_in_use_as_facility_owner',

    'deleteSurveyQuestion_editing_not_allowed',
    'deleteSurveyQuestion_has_conditional_followers',
    'deleteSurveyQuestion_invalid_themeIndex',
    'deleteSurveyQuestion_invalid_questionIndex',
    'deleteSurveyQuestion_invalid_surveyId',

    'deleteSurveyReportLink_invalid_linkId_format',
    'deleteSurveyReportLink_invalid_linkId_value',

    'deleteSurveySegmentFilterAlias_invalid_surveyId_format',
    'deleteSurveySegmentFilterAlias_invalid_aliasId_format',
    'deleteSurveySegmentFilterAlias_invalid_surveyId',
    'deleteSurveySegmentFilterAlias_invalid_aliasId',

    'deleteSurveySegmentation_invalid_surveyId_format',
    'deleteSurveySegmentation_invalid_surveyId',
    'deleteSurveySegmentation_invalid_index',
    'deleteSurveySegmentation_editing_not_allowed',
    'deleteSurveySegmentation_referenced',
    'deleteSurveySegmentation_invalid_index',

    'deleteSurveyTemplate_invalid_surveyTemplateId_format',
    'deleteSurveyTemplate_invalid_surveyTemplateId',

    'deleteSurveyTheme_invalid_surveyId',
    'deleteSurveyTheme_invalid_index',
    'deleteSurveyTheme_editing_not_allowed',

    'deleteSurveyTranslation_invalid_surveyId_format',
    'deleteSurveyTranslation_invalid_languageCode',
    'deleteSurveyTranslation_invalid_surveyId',
    'deleteSurveyTranslation_editing_not_allowed',
    'deleteSurveyTranslation_language_is_default',
    'deleteSurveyTranslation_no_translation_exists',

    'deleteUserRole_invalid_userId',
    'deleteUserRole_invalid_userRoleId',

    'generateSurveyAnswers_invalid_surveyId',
    'generateSurveyAnswers_invalid_surveyId_format',
    'generateSurveyAnswers_invalid_answerCount',
    'generateSurveyAnswers_invalid_survey_state',
    'generateSurveyAnswers_survey_has_answers',

    'invertSurveyQuestion_invalid_surveyId',
    'invertSurveyQuestion_invalid_themeIndex',
    'invertSurveyQuestion_invalid_questionIndex',
    'invertSurveyQuestion_invalid_invert',
    'invertSurveyQuestion_invalid_questionType',

    'login_invalid_email',
    'login_invalid_password',
    'login_invalid_site',
    'login_disabled_user',
    'login_invalid_email',

    'loadSurveyTemplate_invalid_surveyId',
    'loadSurveyTemplate_invalid_templateId',
    'loadSurveyTemplate_editing_not_allowed',
    'loadSurveyTemplate_invalid_global_template',

    'moveAgendaItem_invalid_activityId',
    'moveAgendaItem_invalid_id',
    'moveAgendaItem_invalid_move',
    'moveAgendaItemToIndex_invalid_activityId',
    'moveAgendaItemToIndex_invalid_id',
    'moveAgendaItemToIndex_invalid_targetIndex',

    'moveFolderFile_invalid_privateFileName_format',
    'moveFolderFile_invalid_toFolderId_format',
    'moveFolderFile_file_not_found',
    'moveFolderFile_toFolder_not_found',
    'moveFolderFile_name_in_use_in_target_folder',

    'moveSurveyQuestion_editing_not_allowed',
    'moveSurveyQuestion_invalid_fromThemeIndex',
    'moveSurveyQuestion_invalid_fromQuestionIndex',
    'moveSurveyQuestion_invalid_toThemeIndex',
    'moveSurveyQuestion_invalid_toQuestionIndex',
    'moveSurveyQuestion_invalid_surveyId',
    'moveSurveyQuestion_cannot_move_conditional',
    'moveSurveyQuestion_cannot_move_to_conditional_position',
    
    'moveSurveyTheme_editing_not_allowed',
    'moveSurveyTheme_invalid_fromIndex',
    'moveSurveyTheme_invalid_toIndex',
    'moveSurveyTheme_invalid_surveyId',
    
    'portalAccessKeyLogin_site_not_found',
    'portalAccessKeyLogin_portal_disabled',
    'portalAccessKeyLogin_access_key_login_disabled',
    'portalAccessKeyLogin_invalid_access_key',
    
    'refresh_missing_token',
    'refresh_invalid_token',
    'refresh_expired_token',
    'refresh_disabled_user',
    
    'removeActivityParticipant_invalid_activityId',
    'removeActivityParticipant_invalid_participantId',
    
    'removeWorkgroup_has_children',
    'removeWorkgroup_has_members',
    'removeWorkgroup_invalid_id',
    
    'removeWorkgroupMember_invalid_userId',
    'removeWorkgroupMember_invalid_workgroupId',
    
    'requestNewUserEmail_invalid_newEmail',
    'requestNewUserEmail_invalid_userId',
    'requestNewUserEmail_user_disabled',
    'requestNewUserEmail_email_in_use',
    
    'requestPasswordReset_invalid_email',
    'requestPasswordReset_user_disabled',
    
    'requestPortalMagicLink_invalid_email_format',
    'requestPortalMagicLink_site_disabled',
    'requestPortalMagicLink_portal_disabled',
    'requestPortalMagicLink_magic_link_disabled',
    'requestPortalMagicLink_invalid_email_domain',
    'requestPortalMagicLink_site_not_found',

    'sharePortalResource_invalid_id',
    'sharePortalResource_invalid_resource_type',
    'sharePortalResource_invalid_resource_id',
    'sharePortalResource_id_in_use',
    'sharePortalResource_invalid_config_for_resource_type',
    'sharePortalResource_resource_not_found',
    'sharePortalResource_resource_invalid_reference_type',
    'sharePortalResource_resource_already_shared',

    'unsharePortalResource_invalid_resource_id',
    'unsharePortalResource_resource_not_shared',
    
    'requestUserCreation_invalid_email',
    'requestUserCreation_invalid_firstname',
    'requestUserCreation_invalid_lastname',
    'requestUserCreation_invalid_middlename',
    'requestUserCreation_invalid_password',
    'requestUserCreation_invalid_userId',
    'requestUserCreation_userId_in_use',
    'requestUserCreation_email_in_use',
    
    'sendMeetingInvitation_invalid_activityId',
    'sendMeetingInvitation_invalid_activityType',
    'sendMeetingInvitation_no_participants',
    'sendMeetingInvitation_no_changes',
    
    'sendSurveyFileInvitations_invalid_fileId',
    'sendSurveyFileInvitations_file_already_sent',
    'sendSurveyFileInvitations_file_contains_errors',
    'sendSurveyFileInvitations_invalid_surveyId',
    'sendSurveyFileInvitations_submissions_not_allowed',
    'sendSurveyFileInvitations_invalid_subject',
    'sendSurveyFileInvitations_invalid_body',
    
    'sendUserIntroEmail_invalid_id',
    'sendUserIntroEmail_invalid_email_message',
    'sendUserIntroEmail_user_not_found',
    'sendUserIntroEmail_user_disabled',
    
    'setAnswerSegments_invalid_answerId',
    'setAnswerSegments_invalid_segments',
    'setAnswerSegments_invalid_surveyId',
    'setAnswerSegments_submissions_not_allowed',
    
    'setAnswerSelections_invalid_answerId',
    'setAnswerSelections_invalid_questionIndex',
    'setAnswerSelections_invalid_surveyId',
    'setAnswerSelections_invalid_value',
    'setAnswerSelections_invalid_comment',
    'setAnswerSelections_question_index_exceeds_question_count',
    'setAnswerSelections_skipping_not_allowed',
    'setAnswerSelections_previous_missing',
    'setAnswerSelections_segments_not_set',
    'setAnswerSelections_submissions_not_allowed',
    'setAnswerSelections_question_not_active',
    
    'setReferenceLinks_invalid_id_format',
    'setReferenceLinks_invalid_reference',
    'setReferenceLinks_invalid_link_in_links_array',
    'setReferenceLinks_reference_not_found',
    
    'setSurveyLanguage_invalid_surveyId_format',
    'setSurveyLanguage_invalid_surveyId',
    'setSurveyLanguage_invalid_languageCode',
    'setSurveyLanguage_no_translation_for_language_exists',
    'setSurveyLanguage_editing_not_allowed',
    
    'shareActionPlanLink_invalid_id',
    'shareActionPlanLink_no_access_for_actionPlan',
    'shareActionPlanLink_invalid_recipients',
    'shareActionPlanLink_invalid_message',
    'shareActionPlanLink_invalid_linkId',
    'shareActionPlanLink_invalid_linkType',
    'shareActionPlanLink_link_already_shared_with_one_or_more_recipients',
    
    'startAnswer_invalid_activityId',
    'startAnswer_invalid_assignedAnswerId',
    'startAnswer_invalid_email',
    'startAnswer_invalid_surveyId',
    'startAnswer_no_questions_exist',
    'startAnswer_submissions_not_allowed',
    
    'surveyInvitationFileUpload_invalid_id',
    'surveyInvitationFileUpload_invalid_surveyId',
    'surveyInvitationFileUpload_invalid_fileConent',
    'surveyInvitationFileUpload_survey_not_open_for_answers',
    'surveyInvitationFileUpload_content_too_large',
    'surveyInvitationFileUpload_too_many_lines',
    
    'updateActionPlan_invalid_id',
    'updateActionPlan_invalid_title',
    'updateActionPlan_invalid_description',
    'updateActionPlan_no_access_for_actionPlan',
    
    'updateActionPlanData_invalid_id',
    'updateActionPlanData_invalid_typedata',
    'updateActionPlanData_invalid_type_for_actionPlan',
    'updateActionPlanData_segmentFilter_set_when_no_survey_exists',
    'updateActionPlanData_invalid_segmentFilter',
    
    'updateActionPlanTopic_invalid_id',

    'updateActionPlanTopicRisk_invalid_id_format',
    'updateActionPlanTopicRisk_invalid_id',
    'updateActionPlanTopicRisk_invalid_risk',
    'updateActionPlanTopicRisk_no_access_for_actionPlan',
    
    'updateActionPlanTopicData_invalid_id',
    'updateActionPlanTopicData_invalid_typedata',
    'updateActionPlanTopicData_invalid_description',
    'updateActionPlanTopicData_data_set_when_no_survey_exists',
    'updateActionPlanTopicData_data_survey_themeIndex_invalid',
    'updateActionPlanTopicData_data_survey_questionIndex_invalid',
    'updateActionPlanTopicData_data_survey_indicator_invalid',
    'updateActionPlanTopicData_no_access_for_actionPlan',
    
    'updateActionPoint_invalid_assignedUser',
    'updateActionPoint_invalid_deadline',
    'updateActionPoint_invalid_description',
    'updateActionPoint_invalid_id',
    'updateActionPoint_invalid_id_format',
    'updateActionPoint_invalid_assignedUser_userId',
    'updateActionPoint_invalid_relation',
    'updateActionPoint_no_access_for_actionPlan',
    
    'updateActivity_invalid_description',
    'updateActivity_invalid_start',
    'updateActivity_invalid_end',
    'updateActivity_invalid_duration',
    'updateActivity_invalid_id',
    'updateActivity_invalid_location',
    'updateActivity_invalid_title',
    
    'updateActivityOwner_invalid_activityId_format',
    'updateActivityOwner_invalid_activityId',
    'updateActivityOwner_invalid_ownerId_format',
    'updateActivityOwner_invalid_ownerId',
    'updateActivityOwner_owner_user_disabled',
    'updateActivityOwner_insufficient_owner_permission',
    
    'updateActivityParticipants_invalid_activityId',
    'updateActivityParticipants_invalid_participants_list',
    'updateActivityParticipants_invalid_participant',
    'updateActivityParticipants_duplicate_participant',
    'updateActivityParticipants_duplicate_external_participant',
    'updateActivityParticipants_duplicate_internal_participant',
    'updateActivityParticipants_duplicate_facilitator',
    'updateActivityParticipants_duplicate_minuteTaker',
    'updateActivityParticipants_activityType_does_not_allow_participants',
    'updateActivityParticipants_invalid_userId',
    'updateActivityParticipants_invalid_target_user_permission',
    
    'updateActivityWorkgroup_invalid_activityId_format',
    'updateActivityWorkgroup_invalid_activityId',
    'updateActivityWorkgroup_invalid_workgroupId_format',
    'updateActivityWorkgroup_invalid_workgroupId',
    'updateActivityWorkgroup_workgroupId_set_for_nonMeeting',
    
    'updateAgendaItem_invalid_activityId',
    'updateAgendaItem_invalid_description',
    'updateAgendaItem_invalid_note',
    'updateAgendaItem_invalid_id',
    'updateAgendaItem_invalid_title',
    
    'updateAgendaItemNote_invalid_id',
    'updateAgendaItemNote_invalid_note',

    'updateArticleCategoryTag_invalid_articleId_format',
    'updateArticleCategoryTag_invalid_categoryTag_format',
    'updateArticleCategoryTag_invalid_articleId',
    
    'updateArticleEvaluation_invalid_articleVersionId',
    'updateArticleEvaluation_invalid_evaluationText',
    'updateArticleEvaluation_invalid_evaluationImportance',
    'updateArticleEvaluation_article_not_released',
    
    'updateArticleRequirements_invalid_articleId',
    'updateArticleRequirements_invalid_requirementsText',
    
    'updateComment_invalid_id_format',
    'updateComment_invalid_content',
    'updateComment_invalid_id',
    'updateComment_comment_deleted',
    'updateComment_not_authorized',
    
    'updateExternalLink_invalid_id_format',
    'updateExternalLink_invalid_title',
    'updateExternalLink_invalid_description',
    'updateExternalLink_invalid_url',
    'updateExternalLink_invalid_iconName',
    'updateExternalLink_invalid_showInMenu',
    'updateExternalLink_invalid_id',

    'updateIncident_invalid_id_format',
    'updateIncident_invalid_id',
    'updateIncident_invalid_status',
    'updateIncident_invalid_priority',

    'toggleIncidentVisibility_invalid_id_format',
    'toggleIncidentVisibility_invalid_id',

    'sendMessageToIncidentReporter_invalid_incidentId_format',
    'sendMessageToIncidentReporter_invalid_incidentId',
    'sendMessageToIncidentReporter_invalid_message',
    'sendMessageToIncidentReporter_notifications_not_enabled',
    'sendMessageToIncidentReporter_incident_resolved',

    'sendMessageToIncidentResponders_invalid_incidentId_format',
    'sendMessageToIncidentResponders_invalid_incidentId',
    'sendMessageToIncidentResponders_invalid_message',
    'sendMessageToIncidentResponders_notifications_not_enabled',
    'sendMessageToIncidentResponders_incident_resolved',
    
    'updateInspectionPoint_invalid_id',
    'updateInspectionPoint_invalid_config',
    'updateInspectionPoint_invalid_title',
    'updateInspectionPoint_invalid_instructions',
    'updateInspectionPoint_inspectionPoint_in_use',
    
    'updateFacility_invalid_id_format',
    'updateFacility_invalid_id',
    'updateFacility_invalid_name',
    'updateFacility_invalid_building',
    'updateFacility_invalid_floor',
    'updateFacility_invalid_facility_type_id',
    'updateFacility_invalid_person_id',
    'updateFacility_invalid_created_date',
    
    'updateFacilityInspection_invalid_activityId',
    'updateFacilityInspection_invalid_facilityInspectionId',
    'updateFacilityInspection_invalid_status',
    'updateFacilityInspection_invalid_comment',
    
    'updateFacilityType_invalid_id',
    'updateFacilityType_invalid_name',
    'updateFacilityType_invalid_disabled_value',
    
    'uploadReferenceFile_empty_file',
    'uploadReferenceFile_file_too_big',
    'uploadReferenceFile_invalid_public_file_name',
    'uploadReferenceFile_invalid_reference_type',
    'uploadReferenceFile_invalid_reference_id',
    'uploadReferenceFile_public_file_name_in_use',
    'uploadReferenceFile_invalid_data',
    'uploadReferenceFile_invalid_file_extension',
    
    'updateFileFolder_invalid_id_format',
    'updateFileFolder_invalid_name',
    'updateFileFolder_invalid_parent_folder_id',
    'updateFileFolder_invalid_id',
    'updateFileFolder_name_in_use_by_sibling',
    'updateFileFolder_cannot_set_parent_to_child_folder',
    
    'setInternalArticleDeleted_invalid_internalArticleId_format',
    'setInternalArticleDeleted_invalid_internalArticleId',
    'setInternalArticleDeleted_invalid_isDeleted',

    'updateInternalArticle_invalid_internalArticleId_format',
    'updateInternalArticle_invalid_internalArticleId',
    'updateInternalArticle_invalid_title_format',
    'updateInternalArticle_invalid_description_format',
    'updateInternalArticle_invalid_ownerUserId_format',
    'updateInternalArticle_invalid_userId',
    'updateInternalArticle_user_disabled',
    'updateInternalArticle_user_insufficient_permissions',
    'updateInternalArticle_invalid_date_format',
    'updateInternalArticle_invalid_evaluationImportance_format',
    'updateInternalArticle_invalid_evaluationText_format',
    'updateInternalArticle_invalid_changeDescription_format',
    
    'updateLocation_invalid_id_format',
    'updateLocation_invalid_id',
    'updateLocation_invalid_name',
    'updateLocation_invalid_country',
    'updateLocation_invalid_address',
    'updateLocation_invalid_postal_code',
    'updateLocation_invalid_city',
    
    'updateOrganizationOwner_invalid_firstname',
    'updateOrganizationOwner_invalid_middlename',
    'updateOrganizationOwner_invalid_lastname',
    
    'updatePermissionGroup_invalid_userId',
    'updatePermissionGroup_invalid_permissionGroup',
    'updatePermissionGroup_permissionGroup_not_allowed',
    'updatePermissionGroup_invalid_selection',
    'updatePermissionGroup_requires_admin_permission',
    
    'updatePerson_invalid_id_format',
    'updatePerson_invalid_id',
    'updatePerson_invalid_name',
    'updatePerson_invalid_role',
    'updatePerson_invalid_email',
    'updatePerson_invalid_phone',

    'updateSurveyIntroduction_invalid_surveyId',
    'updateSurveyIntroduction_invalid_text',
    'updateSurveyIntroduction_invalid_languageCode',
    'updateSurveyIntroduction_invalid_surveyId',
    'updateSurveyIntroductionText_invalid_languageCode',
    'updateSurveyIntroduction_editing_not_allowed',

    'updateSurveyQuestion_editing_not_allowed',
    'updateSurveyQuestion_invalid_indicators',
    'updateSurveyQuestion_invalid_questionIndex',
    'updateSurveyQuestion_invalid_surveyId',
    'updateSurveyQuestion_invalid_themeIndex',
    'updateSurveyQuestion_invalid_title',
    'updateSurveyQuestion_invalid_translations',
    'updateSurveyQuestion_invalid_canComment',
    'updateSurveyQuestion_invalid_question',
    'updateSurveyQuestion_invalid_option_count',
    'updateSurveyQuestion_invalid_option_translations',
    'updateSurveyQuestion_invalid_question_type_change',
    'updateSurveyQuestion_conditional_value_in_use',
    'updateSurveyQuestion_invalid_type',
    'updateSurveyQuestion_invalid_invertScore',
    'updateSurveyQuestion_invalid_scored',
    'updateSurveyQuestion_invalid_options',
    'updateSurveyQuestion_invalid_config',
    'updateSurveyQuestion_invalid_conditional',
    'updateSurveyQuestion_invalid_conditional_values',
    'updateSurveyQuestion_invalid_conditional_type',
    'updateSurveyQuestion_invalid_conditional_trigger',
    'updateSurveyQuestion_invalid_conditional_sequence',

    'updateSurveySegmentation_invalid_surveyId',
    'updateSurveySegmentation_invalid_index',
    'updateSurveySegmentation_invalid_toIndex',
    'updateSurveySegmentation_invalid_surveyId_format',
    'updateSurveySegmentation_editing_not_allowed',
    'updateSurveySegmentation_invalid_languagecode',
    'updateSurveySegmentation_inconsistent_value_count',
    'updateSurveySegmentation_inconsistent_translation_definition',
    'updateSurveySegmentation_duplicate_segmentation_name',
    'updateSurveySegmentation_invalid_data_format',
    'updateSurveySegmentation_invalid_value_count',
    'updateSurveySegmentation_invalid_segmentation_value',
    'updateSurveySegmentation_duplicate_segmentation_value',
    'updateSurveySegmentation_invalid_segmentation_name',
    'updateSurveySegmentation_referenced',

    'updateSurveySegmentFilterAlias_invalid_surveyId_format',
    'updateSurveySegmentFilterAlias_invalid_aliasId_format',
    'updateSurveySegmentFilterAlias_invalid_name',
    'updateSurveySegmentFilterAlias_invalid_segmentFilter_format',
    'updateSurveySegmentFilterAlias_invalid_surveyId',
    'updateSurveySegmentFilterAlias_invalid_segmentFilter_value',
    'updateSurveySegmentFilterAlias_invalid_aliasId',
    'updateSurveySegmentFilterAlias_name_in_use',
    'updateSurveySegmentFilterAlias_segmentFilter_in_use',

    'updateSurveyTheme_invalid_surveyId',
    'updateSurveyTheme_invalid_index',
    'updateSurveyTheme_invalid_newTheme',
    'updateSurveyTheme_editing_not_allowed',

    'updateSurveyThemeText_invalid_surveyId_format',
    'updateSurveyThemeText_invalid_surveyId',
    'updateSurveyThemeText_editing_not_allowed',
    'updateSurveyThemeText_invalid_index',
    'updateSurveyThemeText_invalid_text',
    'updateSurveyThemeText_invalid_languageCode',
    'updateSurveyThemeText_text_in_use',

    'updateUser_invalid_firstname',
    'updateUser_invalid_id',
    'updateUser_invalid_lastname',
    'updateUser_invalid_middlename',

    'updateUserInitials_invalid_id',
    'updateUserInitials_invalid_initials',
    'updateUserInitials_initials_in_use',

    'updateUserNotification_invalid_notificationId_format',
    'updateUserNotification_invalid_userId_format',

    'updateUserRole_invalid_userId',
    'updateUserRole_invalid_userRoleId',
    'updateUserRole_invalid_roleId',
    'updateUserRole_invalid_start',
    'updateUserRole_invalid_end',
    'updateUserRole_invalid_duration',
    'updateUserRole_invalid_userId',

    'updateUserSettings_invalid_userId',
    'updateUserSettings_invalid_settings',

    'updateSiteApplicationSettings_invalid_applicationSettings',
    'updateSiteApplicationSettings_invalid_employeePortalSettings',
    'updateSiteApplicationSettings_invalid_employeePortalSettings_enabled',
    'updateSiteApplicationSettings_invalid_employeePortalSettings_resetTimeStamp',
    'updateSiteApplicationSettings_invalid_employeePortalSettings_authentication',
    'updateSiteApplicationSettings_invalid_employeePortalSettings_magicLink',
    'updateSiteApplicationSettings_invalid_employeePortalSettings_magicLink_enabled',
    'updateSiteApplicationSettings_invalid_employeePortalSettings_magicLink_validDomains',
    'updateSiteApplicationSettings_invalid_employeePortalSettings_publicKey',
    'updateSiteApplicationSettings_invalid_employeePortalSettings_publicKey_enabled',
    'updateSiteApplicationSettings_invalid_employeePortalSettings_publicKey_accessKey',
    'updateSiteApplicationSettings_invalid_settings',
    'updateSiteApplicationSettings_publicKey_enabled_but_accessKey_empty',

    'updateUserStatus_invalid_id',

    'uploadFacilityInspectionImage_invalid_facilityInspectionId_format',
    'uploadFacilityInspectionImage_invalid_facilityInspectionId',
    'uploadFacilityInspectionImage_invalid_privateFileName',
    'uploadFacilityInspectionImage_privateFileName_in_use',
    'uploadFacilityInspectionImage_invalid_publicFileName',
    'uploadFacilityInspectionImage_publicFileName_in_use',
    'uploadFacilityInspectionImage_invalid_file_extension',
    'uploadFacilityInspectionImage_file_extension_mismatch',
    'uploadFacilityInspectionImage_invalid_data',
    'uploadFacilityInspectionImage_file_too_large',
    'uploadFacilityInspectionImage_non_image_file',

    'updateUserRole_invalid_roleId',
    'updateUserRole_invalid_userRoleId',

    'updateWorkgroup_invalid_name',
    'updateWorkgroup_invalid_parentId',
    'updateWorkgroup_invalid_type',
    'updateWorkgroup_invalid_workgroupId',

    'createFileUploadSlot_invalid_id_format',
    'createFileUploadSlot_id_in_use',
] as const;
